import React, { PureComponent } from 'react';
import TimeUtils from 'app/common/util/TimeUtils';
import { CoordinationUtils } from 'app/common/util/CoordinationUtils';
import { Flex } from 'app/components/common/Flex';
import { Progress } from 'antd';
import './TargetTime.less';

export class TargetTime extends PureComponent<{ targetTime: Date }, { progressPercent: number }> {
    private intervalId: NodeJS.Timer;

    constructor(props) {
        super(props);

        // TODO Replace with actual creationTime if needed, need to update Coordination model
        const creationTime = TimeUtils.addMinutes(
            this.props.targetTime,
            -CoordinationUtils.DEFAULT_COORDINATION_DURATION,
        );

        this.state = {
            progressPercent: this.initProgress(creationTime),
        };
    }

    componentDidMount() {
        this.intervalId = setInterval(
            () =>
                this.setState(state => ({
                    progressPercent: state.progressPercent + 1,
                })),
            TimeUtils.MIN_TO_MS,
        );
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    initProgress = (creationTime: Date) => {
        const elapsedMin = Math.max(0, TimeUtils.diffInMinutes(new Date(), creationTime));
        const percent = (100 * elapsedMin) / CoordinationUtils.DEFAULT_COORDINATION_DURATION;
        return Math.floor(percent);
    };

    getProgressColor = () => {
        if (this.state.progressPercent >= 100) {
            return '#FF0000';
        } else if (this.state.progressPercent >= 90) {
            return '#fe4000';
        } else if (this.state.progressPercent >= 80) {
            return '#f96000';
        } else if (this.state.progressPercent >= 70) {
            return '#f17a00';
        } else if (this.state.progressPercent >= 60) {
            return '#e59100';
        } else if (this.state.progressPercent >= 50) {
            return '#d7a700';
        } else if (this.state.progressPercent >= 40) {
            return '#c4ba00';
        } else if (this.state.progressPercent >= 30) {
            return '#aecd00';
        } else if (this.state.progressPercent >= 20) {
            return '#91df00';
        } else if (this.state.progressPercent >= 10) {
            return '#6aef00';
        } else {
            return '#00FF00';
        }
    };

    render() {
        return (
            <Flex className="target-time" direction="vertical" grow={false} shrink={false}>
                <span>Target Time</span>
                <span className="time">{TimeUtils.formatHHMM(this.props.targetTime)}</span>
                <Progress
                    size="small"
                    showInfo={false}
                    percent={this.state.progressPercent}
                    trailColor="#A3A3A3"
                    strokeColor={this.getProgressColor()}
                />
            </Flex>
        );
    }
}
